/**
 * plugins/webfontloader.js
 *
 * webfontloader는 index.html에서 CDN으로 로드 (window.WebFont).
 * Vite가 npm 패키지 webfontloader를 사전 번들할 때 UMD 변환이 느려 페이지 로딩이 멈추므로 CDN 사용.
 * @see https://github.com/typekit/webfontloader
 */
export function loadFonts() {
  if (typeof window === 'undefined' || !window.WebFont) return
  window.WebFont.load({
    google: {
      families: ['Public+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap'],
    },
  })
}
export default function () {
  loadFonts()
}
